import * as React from "react"
import {useEffect} from "react"
import {Check} from "lucide-react"

import {cn} from "../../shadCn/lib/utils"
import {Command, CommandEmpty, CommandGroup, CommandInput, CommandItem,} from "../../shadCn/components/ui/command"
import {Popover, PopoverContent, PopoverTrigger,} from "../../shadCn/components/ui/popover"
import {CommandList} from "cmdk";
import {ComboBoxSelectorTrigger} from "./ComboBoxSelectorTrigger";


function SelectComboBoxForCreate({options, required, target, data, defaultValue, search}){
    const [open, setOpen] = React.useState(false)
    const [value, setValue] = React.useState(defaultValue ?? null)

    useEffect(()=>{
        setValue(defaultValue)
    }, [defaultValue])

    const isRequiredEmpty = required && (!data.data || !data.data[target] || data.data[target] === "");

    useEffect(() => {
        if(required){
            data.fnc(prev => ({
                ...prev,
                required_validate: { ...prev.required_validate, [target]: defaultValue ? true : false }
            }));
        }
    }, [])

    const handler = (selected) => {
        if(value === selected){
            setValue(null);
            data.fnc((prev) => {
                const updatedSearchObject = { ...prev };
                delete updatedSearchObject[target];
                if(required) {
                    const updatedRequiredValidate = {...prev.required_validate, [target]: false};
                    return { ...updatedSearchObject, required_validate: updatedRequiredValidate };
                }else{
                    return updatedSearchObject;
                }
            })
        }else{
            setValue(selected);
            if(required){
                data.fnc((prevSearchObject) => ({
                    ...prevSearchObject,
                    [target]: selected,
                    required_validate: { ...prevSearchObject.required_validate, [target]: true }
                }))
            }else{
                data.fnc((prevSearchObject) => ({
                    ...prevSearchObject,
                    [target]: selected
                }))
            }
        }

        setOpen(false)
    }

    if(options) {
        const displayLabel = value ? options.find((option) => option.id === value)?.name : "선택";

        return (
            <div className="simms-drawer-field selector-field">
                <div className="selector-root selector-root--ios no-drag">
                    <Popover open={open} onOpenChange={setOpen}>
                        <PopoverTrigger asChild>
                            <ComboBoxSelectorTrigger
                                label={displayLabel}
                                open={open}
                                selected={Boolean(value)}
                                isRequiredEmpty={isRequiredEmpty}
                            />
                        </PopoverTrigger>

                    <PopoverContent className="w-[200px] p-0" align={"start"}>
                        <Command>
                            {search &&
                                <>
                                    <CommandInput placeholder="검색" />
                                    <CommandEmpty>검색결과 없음</CommandEmpty>
                                </>
                            }
                            <CommandGroup>
                                <CommandList className="max-h-[10rem] overflow-y-auto w-full">
                                    {options.map((option) => (
                                        <CommandItem
                                            key={option.id}
                                            value={option.id}
                                            onSelect={() => handler(option.id)}
                                            className={"text-[12px]"}
                                        >
                                            <Check
                                                className={cn(
                                                    "mr-2 h-4 w-4",
                                                    value === option.id ? "opacity-100" : "opacity-0"
                                                )}
                                            />
                                            {option.name}
                                        </CommandItem>
                                    ))}
                                </CommandList>
                            </CommandGroup>
                        </Command>
                    </PopoverContent>
                </Popover>
                </div>
            </div>
        )
    }
}

export {SelectComboBoxForCreate}